<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            @doSave="doSave"
            @doSavePrint="doSavePrint"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Create New Dispatch Order
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text class="text--primary mt-6">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="client"
                    :items="clients"
                    :loading="isLoading"
                    :search-input.sync="search"
                    clearable
                    no-data-text="Client not found"
                    hide-details
                    hide-selected
                    item-text="keyword"
                    outlined
                    label="Dispatch To"
                    return-object
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Enter <strong>Name</strong> or <strong>Client Code</strong>
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ attr, on, item, selected }">
                      <div
                        v-bind="attr"
                        :input-value="selected"
                        color="#A3A8AD"
                        v-on="on">
                          <span v-text="item.name"></span>
                          <span v-text="item.code" v-if="item.code" class="grey-color ml-2"></span>
                      </div>

                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                        <v-list-item-subtitle v-text="item.code"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>

                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.client_contact_no"
                    label="Contact No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="delivery.client_address"
                    label="Address"
                    auto-grow
                    rows="1"
                    outlined
                    hide-details
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.plate_no"
                    label="Plate No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="5" offset-md="2">
              <v-row>
                <v-col cols="12">
                  <v-menu
                      v-model="menuCreatedDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="delivery.delivery_date"
                          label="Dispatch Date"
                          append-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery.delivery_date"
                        @input="menuCreatedDate = false"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.ref_no"
                    label="Reference No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="delivery.remarks"
                    label="Remarks"
                    auto-grow
                    rows="1"
                    outlined
                    maxlength="255"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>



          <v-card-title class="text-h6 mt-10 mr-0 pr-0">

            <v-spacer></v-spacer>
            <v-btn
              :disabled="client==null"
              class="ml-md-10"

              large
              depressed
              color="primary"
              @click="showForDelivery()"
            >
              <v-icon dark class="mr-2">
                mdi-cube-send
              </v-icon>
              Add Item For Dispatch
            </v-btn>
          </v-card-title>

          <v-sheet
            rounded
            class="pa-5 px-6 pb-7"
            color="#f3f3f3">

            <v-data-table
              :headers="headers"
              :items="items"
              class="item-data-input"
              :loading="loading"
              :items-per-page="1000"
              hide-default-footer
              loading-text="Loading Items..."
              no-data-text="No Items"
              ref="table">

              <template v-slot:item.shipping_mark="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.shipping_mark"
                  placeholder="Shipping Mark"
                  dense
                  disabled
                  outlined
                  readonly
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.description="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.description"
                  placeholder="Description"
                  dense
                  disabled
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.qty="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.qty"
                  @focus="$event.target.select()"
                  placeholder="Qty"
                  dense
                  disabled
                  outlined
                  @keypress="filter($event)"
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.action="{ item }">
                <v-icon
                  color=" darken-2"
                  @click="deleteItem(item)">
                  mdi-close
                </v-icon>
              </template>

              <!-- <template v-slot:body.append>
                <tr>
                  <td class="text-center" colspan="6">
                    <div class="mt-4">
                          <v-btn
                            fab
                            dark
                            small
                            depressed
                            color="primary"
                            class="mb-1"
                            @click="addMoreItems()"
                          >
                            <v-icon dark>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <br>
                          <span class="primary-color font-weight-medium">Add Item</span>
                    </div>
                  </td>
                </tr>
              </template> -->

            </v-data-table>

          </v-sheet>
        </v-card-text>
        <v-card-actions class="ml-2 my-2 mt-4">
          <v-btn
            color="primary"
            depressed
            large
            @click="doSave()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Create Dispatch Order</span>
          </v-btn>
        </v-card-actions>

      </v-card>

      <v-dialog v-model="forDeliveryDialog.show" persistent max-width="800px" content-class="default-dialog-container">
        <ForDelivery
          :forDeliveryDialog="forDeliveryDialog"
          @selectItem="selectItem"
          >
        </ForDelivery>
      </v-dialog>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<style>
  .input-footer {
    max-width: 150px
  }

  .v-data-table.item-data-input > .v-data-table__wrapper > table > thead > tr > th {
    padding: 0 8px
  }

  .v-data-table.item-data-input > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0 8px
  }

  .theme--light.v-data-table.item-data-input > .v-data-table__wrapper > table > thead > tr > th:last-child {
    color: #f3f3f3
  }

  .theme--light.v-data-table.item-data-input tbody td {
    /* height: 40px; */
    border: none;
    border-bottom: none!important;
  }
  .theme--light.v-data-table.item-data-input tbody tr:not(:last-child) {
    border-bottom: none;
  }

  .theme--light.v-data-table.item-data-input > .v-data-table__wrapper > table > thead > tr:last-child > th{
    border-bottom: none!important;
  }

  .v-data-table.item-data-input > .v-data-table__wrapper > table tr {
    background-color: #f3f3f3
  }

  .item-data-input tr:hover {
     background-color: #f3f3f3 !important;
  }
</style>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max, numeric } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import Loader from '@/components/Loader.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import { mapGetters } from "vuex";
  import ActionButtons from '@/components/ActionButtons.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import ForDelivery from '@/components/ForDelivery.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: 'Email must be valid',
  })

  extend('numeric', {
    ...numeric,
    message: '{_field_} should be numeric',
  })

  export default {
    name: 'DOCreateNew',
    data: () => ({
      operationsNamespace: 'operations',
      id: null,
      forDeliveryDialog: {
        show: false,
        selected_items: [],
        client_id: ''
      },
      menuCreatedDate: false,
      loading: false,
      isLoading: false,
      awaitingSearch: false,
      clients: [],
      client: null,
      search: null,
      menuEstDeliveryDate: false,
      perPage: 2000,
      actionBtnSettings: {
        edit: 0,
        save: 0,
        close: 1,
        print: 0,
        refresh: 0,
        send: 0,
        save_and_print: 0,
        save_disabled: true,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: true
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      delivery: {
        id: '',
        delivery_no: '',
        plate_no: '',
        ref_no: '',
        client: '',
        client_id: '',
        client_contact_no: '',
        client_address: '',
        delivery_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        remarks: ''
      },
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      subNavs: [
        {
          text: 'Dispatch Orders',
          disabled: false,
          exact: true,
          to: {
            name: 'delivery-orders'
          },
        },
        {
          text: 'Create New Dispatch Order',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      items: [],
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 270
        },
        {
          text: 'Item',
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: 'Qty',
          align: 'center',
          value: 'qty',
          sortable: false,
          width: 180
        },
        {
          text: 'x',
          value: 'action',
          align: 'center',
          sortable: false,
          width: 50
        }
      ]
    }),
    watch: {
      client: function (val) {
        if(val == null){
          this.delivery.client_id = ''
          this.delivery.client_contact_no = ''
          this.delivery.client_address = ''

          this.forDeliveryDialog.client_id = ''
          this.forDeliveryDialog.selected_items = []
          this.items = []
          this.generateItemRows()

          this.actionBtnSettings.save_and_print = true
          this.actionBtnSettings.save_disabled = true
          this.actionBtnSettings.save_and_print_disabled = true
        }else{
          this.delivery.client_id = val.id
          this.delivery.client_contact_no = val.contact_no
          this.delivery.client_address = val.address

          this.forDeliveryDialog.client_id = val.id
          this.forDeliveryDialog.selected_items = []
          this.items = []
          this.generateItemRows()

          this.actionBtnSettings.save_and_print = false
          this.actionBtnSettings.save_disabled = false
          this.actionBtnSettings.save_and_print_disabled = false
        }

      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.searchClients()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      }
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'formatNumberAmountNoComma', 'getCurrentUser']),
      forUpdate: function(){
        return this.id ? true : false
      },
      subTotal: function(){
        let qty = 0

        this.items.forEach(obj => {
          let hasValidData = true
          Object.keys(obj).forEach(key => {
            if(obj[key].trim().length == 0){
              hasValidData = false
            }
          })

          if(hasValidData){
            qty = qty + Number(this.formatNumberAmountNoComma(this.$numeral, obj['qty']))
          }
        })
        return qty
      },
    },
    methods: {
      scrollToElement (element, body) {
        this.$scrollTo(
          element,
          500,
          {
            container: body,
            easing: 'ease-in',
            lazy: false,
            offset: -100,
            force: true,
            cancelable: true,
            onStart: function(element) {
              // scrolling started
            },
            onDone: function(element) {
              // scrolling is done
            },
            onCancel: function() {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
        )
      },
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      showForDelivery () {
        this.forDeliveryDialog.show = true
      },
      selectItem (selectedItems) {
        let self = this
        selectedItems.forEach(obj => {
          self.items.unshift(
            {
              booking_detail_id: obj['id'],
              description: obj['item_description'],
              qty: obj['qty'],
              shipping_mark: obj['shipping_mark']
            }
          )

          this.forDeliveryDialog.selected_items.push(obj['id'])
        })

      },
      doClose (){
        this.cancelDelivery()
      },
      cancelDelivery() {
        this.dialog = {
          show: true,
          title: 'Cancel Delivery Order',
          body: 'Are you sure you want to cancel this delivery order?',
          type: 'close',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },

      doSavePrint (){

      },
      searchClients () {
        if (this.isLoading) {
          return false
        }

        const params = {
          per_page: this.perPage,
          search: this.search
        }

        this.isLoading = true
        let self = this
        this.$http.plain.get('/clients', { params: params })
          .then(response => {
            this.clients = response.data.clients
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.isLoading = false
          })
      },
      doConfirm () {
        this.dialog.show = false

        if(this.dialog.type == 'close'){
          this.$router.push({ name: 'delivery-orders' })
        }else{

          if(Object.prototype.hasOwnProperty.call(this.dialog.item, "booking_detail_id")){
            this.forDeliveryDialog.selected_items.splice(this.forDeliveryDialog.selected_items.indexOf(this.dialog.item.booking_detail_id), 1)
          }else{
            this.forDeliveryDialog.selected_items.splice(this.forDeliveryDialog.selected_items.indexOf(this.dialog.item.id), 1)
          }

          this.items.splice(this.items.indexOf(this.dialog.item), 1)

          if(this.dialog.item.description.length > 0){
            this.showMessage(this.dialog.item.description + " has been successfully deleted", 'success')
          }
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        if(item.description.length == 0){
          this.items.splice(this.items.indexOf(item), 1)
          return false
        }
        this.dialog = {
          show: true,
          title: 'Delete Item',
          body: 'Are you sure you want to delete '+item.description+' item?',
          type: 'item',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      addMoreItems(){
        console.log("addMoreItems");
        this.items.push(
          { shipping_mark: '', description: '', qty: ''}
        )
      },
      generateItemRows() {
        // for (let i = 0; i < 1; i++) {
        //   this.items.push(
        //     { shipping_mark: '', description: '', qty: ''}
        //   )
        // }
      },
      addNew () {
        let self = this
        let data = {
          deliver_to_contact_no: this.delivery.client_contact_no,
          deliver_to_address: this.delivery.client_address,
          client_id: this.delivery.client_id,
          ref_no: this.delivery.ref_no,
          plate_no: this.delivery.plate_no,
          delivery_date: this.delivery.delivery_date,
          remarks: this.delivery.remarks,
          items: this.items
        }

        this.$http.secured.post(this.operationsNamespace+'/deliveries', data)
          .then(response => {
            this.$router.push({ name: 'delivery-orders', query: { added: true, message: "Delivery Order has been successfully created" } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            this.scrollToElement('body', 'body')
          })
          .then(function () {
            self.loading = false
          })
      },
      async doSave () {
        this.alerMessage.show = false

        if(this.loading){
          return false;
        }

        this.loading = true

        if(this.forUpdate){
          this.update()
        }else{
          this.addNew()
        }
      },
      clear () {
        Object.keys(this.delivery).forEach(key => {
          this.delivery[key] = ''
        })

        this.$refs.observer.reset()

      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.generateItemRows()
      this.searchClients()
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      Loader,
      ActionButtons,
      AlertMessage,
      ForDelivery
    }
  }
</script>
